import React from 'react';
import { InputGroup } from '@podiumhq/design-system';

import { FormFieldWrapper } from '../FormElements';

import CreditCardFieldRightElement from './CreditCardFieldRightElement';

const CreditCardFieldWrapper = ({
  boxProps = {},
  children,
  error,
  id,
  ...rightElementProps
}) => (
  <FormFieldWrapper
    error={error}
    displayErrorIcon={false}
    id={id}
    inputGroupSize="lg"
    {...boxProps}
  >
    <InputGroup>
      {children}
      <CreditCardFieldRightElement error={error} {...rightElementProps} />
    </InputGroup>
  </FormFieldWrapper>
);

export default CreditCardFieldWrapper;
